<template>
  <div>
    <!-- 加工阶段 -->
    <common-dialog
      ref="dialog"
      width="730px"
      show-save-button
      unit="生产工序"
      edit-title
      id-key="MachiningStageId"
      :data="data"
      :line-form="true"
      form-label-width="120px"
      :form-rules="rules"
      :before-save="onBeforeSave"
      :save-func="api.save"
      @opened="onOpened"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="序号" prop="Sn">
              <el-input type="number" v-model="data.Sn" placeholder="请输入序号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="编号前缀" prop="Prefix">
              <el-input type="text" v-model="data.Prefix" @input="handleInput" placeholder="请输入编号前缀(输入类型:字母)" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否启用" prop="Status">
              <el-select v-model="data.Status">
                <el-option :value="1" label="是"></el-option>
                <el-option :value="0" label="否"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="名称" prop="Name">
              <el-input v-model="data.Name" placeholder="请输入名称" />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="启动特殊加工" prop="UseProcess">
              <el-select v-model="data.UseProcess">
                <el-option :value=true label="是"></el-option>
                <el-option :value=false label="否"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :span="12">
            <el-form-item label="以领代耗" prop="ClaimConsumables">
              <el-select v-model="data.ClaimConsumables">
                <el-option :value=true label="是"></el-option>
                <el-option :value=false label="否"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="委外是否适用" prop="IsOutsourcingApply">
              <el-select v-model="data.IsOutsourcingApply">
                <el-option :value="true" label="是"></el-option>
                <el-option :value="false" label="否"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="默认生产部门" prop="DpName" label-width="120px">
              <tree-select
                ref="dpTreeSelect"
                :props="DpProps"
                :options="DpTreeData"
                :value="data.DpId"
                :clearable="false"
                :accordion="true"
                :parentSelect="true"
                placeholder="请选择"
                @node-select="onDpTreeSelect($event)"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="默认委外单位" prop="TradeUnitld">
              <el-select v-model="data.TradeUnitId" clearable>
                <el-option v-for="item in tradeUnitList" :key="item.TradeUnitId" :value="item.TradeUnitId" :label="item.FullName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="报工后自动入库" prop="Status">
              <el-select v-model="data.IsAutoIn">
                <el-option :value="true" label="是"></el-option>
                <el-option :value="false" label="否"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="自动耗料" prop="Status">
              <el-select v-model="data.IsAutoUse">
                <el-option :value="true" label="是"></el-option>
                <el-option :value="false" label="否"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合格入库仓" prop="InWarehouseId">
              <wms-select v-model="data.InWarehouseId"></wms-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="不合格入库仓" prop="UnqualifiedInWarehouseId">
              <wms-select v-model="data.UnqualifiedInWarehouseId"></wms-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="启用商标" prop="UseTradeMark">
              <el-select v-model="data.UseTradeMark">
                <el-option :value=true label="是"></el-option>
                <el-option :value=false label="否"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="退料工单" prop="IsRetreat">
              <el-select v-model="data.IsRetreat">
                <el-option :value=true label="是"></el-option>
                <el-option :value=false label="否"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="24">
            <el-form-item label="备注" prop="Remark">
              <el-input type="textarea" v-model="data.Remark" placeholder="请输入备注内容" />
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'
import treeSelect from '@/components/common/treeSelect'
import wmsSelect from '@/components/basedata/basedoc/wms/select'
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    treeSelect,
    wmsSelect
  },
  data() {
    return {
      api: require('@/api/stock/machiningStage').default,
      dpApi: require('@/api/ent/dp').default,
      formApi: require('@/api/sy/formSetting').default,
      tradeUnitApi: require('@/api/ba/tradeUnit').default,
      tradeUnitList: [],
      data: {
        Sn: null,
        Name: null,
        Status: 0,
        UseProcess: false,
        ClaimConsumables: false,
        IsOutsourcingApply: false,
        Dpld: null,
        TradeUnitId: null,
        IsRetreat: false,
        Remark: null,
        MachiningStageId: null,
        Prefix: null,
        IsAutoIn: false,
        InWarehouseId: null,
        UnqualifiedInWarehouseId: null,
        UseTradeMark:false,
      },
      rules: {
        Name: [{ required: true, message: '名称不能为空' }],
        Sn: [{ required: true, message: '序号不能为空' }],
        Prefix: [{ required: true, message: '编码前缀不能为空' }]
      },
      showList: [],
      DpTreeData: [],
      DpProps: {
        value: 'DpId',
        label: 'DpName',
        children: 'children'
      }
    }
  },
  methods: {
    // 打开时获取显示显示列表
    onOpened() {
      let modeName = this.urlHash ? this.urlHash.split('/').join('') : location.hash.split('/').slice(1).join('')
      this.formApi.list({ type: modeName }).then(res => {
        this.showList = res.Data?.map(x => x.ShowField)
      })

      this.tradeUnitApi.list({ TradeUnitType: 3, Status: 1 }).then(res => {
        if (res.Code === 0) {
          this.tradeUnitList = res.Data
        }
      })
    },
    //判断显示
    iShow(data) {
      if (this.showList == null || this.showList.length === 0) return true
      return this.showList.indexOf(data) !== -1 ? true : false
    },
    onCreateOpened() {
      this.dpApi.list({}).then(res => (this.DpTreeData = this.$commonJs.toTreeData(res.Data, 'DpId')))
      this.data.MachiningStageId = null
      this.api.getMaxSn().then(res => {
        this.data.Sn = res
      })
    },
    onEditOpened(data) {
      this.api.info(data.MachiningStageId).then(res => {
        if (res.Code === 0) {
          this.data = { ...res.Data }
          // 部门
          this.dpApi.list({}).then(res => {
            if (res.Code === 0) {
              this.DpTreeData = this.$commonJs.toTreeData(res.Data, 'DpId')
              this.$refs.dpTreeSelect.setData(this.data.DpId)
            }
          })
        }
      })
    },
    onDpTreeSelect(t) {
      this.data.DpName = !t ? '' : t.DpName
      this.data.DpId = !t ? null : t.DpId
    },
    onClosed() {
      this.showList = []
      this.$refs.dpTreeSelect.clearHandle()
    },
    onInputSn(e) {
      this.data.Sn = Number(e)
    },
    onBeforeSave() {
      // console.log(this.data);

      // this.data = {...this.data,Status:this.data.Status == true ? 1 : 0}
      if (!this.data.IsAutoIn) {
        if (this.data.IsAutoUse) {
          this.$message.warning('非自动入库，无法自动耗料')
          return false
        }
      }
    },
    handleInput(event) {
      // 只允许输入大小写字母
      const regex = /^[a-zA-Z]*$/
      if (regex.test(event)) {
        this.data.Prefix = event
      } else {
        // 去掉非字母字符
        this.data.Prefix = event.replace(/[^a-zA-Z]/g, '')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .notBottom .el-form-item__content {
  border-bottom: none;
}
</style>
